import { ShieldCheck } from "lucide-react";

const DpiitBadge = ({ variant = "light" }) => {
  const isDark = variant === "dark";
  return (
    <div
      className={`inline-flex items-center gap-3 px-3 py-2 border ${
        isDark
          ? "border-white/25 bg-white/5 text-white"
          : "border-navy/20 bg-white text-navy"
      }`}
    >
      <div
        className={`grid h-8 w-8 place-items-center border ${
          isDark ? "border-[color:var(--gold)]/60" : "border-[color:var(--gold)]"
        }`}
      >
        <ShieldCheck
          className="h-4 w-4 text-[color:var(--gold)]"
          strokeWidth={1.6}
        />
      </div>
      <div className="leading-tight">
        <p
          className={`font-mono text-[9px] uppercase tracking-[0.28em] ${
            isDark ? "text-white/60" : "text-navy/60"
          }`}
        >
          Recognized
        </p>
        <p className="font-serif text-[13px] tracking-tight">
          DPIIT · Govt. of India
        </p>
      </div>
    </div>
  );
};

export default DpiitBadge;
